// Import modules
import Navigation from './modules/_navigation'
import ObjectFit from './modules/_object-fit'
import Print from './modules/_print'
import VideoModal from './modules/_video-modal'
import FooterAccordions from './modules/_footer'
import NavigationSearch from './modules/_navigation-search'
import initTippy from './modules/_tippy'
import megaMenu from './modules/mega-menu'

// Use modules
Navigation()
ObjectFit()
Print()
VideoModal()
FooterAccordions()
NavigationSearch()
initTippy()
megaMenu()

/**
 * If you want to use React in this project, just use the function below:
 * require('./app')
 */

require('./app')